import 'rxjs/add/operator/switchMap';
import 'rxjs/add/operator/map'
import 'rxjs/add/operator/mergeMap'
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/of';

import 'rxjs/add/observable/merge';
import 'rxjs/add/observable/concat';
import 'rxjs/add/operator/do';

import INSPECTION_DETAIL_ACTIONS from '../../constants/actions/inspection';
import InspectionApi from '../../api/inspection';
import InspectionDetailAction from '../actions/inspection';
import {Observable} from 'rxjs-compat';
import {toast} from 'react-toastify';
import {CONFIG_NOTIFY, MESSAGES_NOTIFY} from '../../constants/app/inspection';

class InspectionDetailEpic {
    static loadDetail = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            const inspection = api.getInfoInspection(payload)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.loadInfoInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadPolicy(response.policyNumber))
                ))
                .catch(error => Observable.of(InspectionDetailAction.loadInfoInspectionError({
                    message: error.message,
                    status: error.status
                })));
            const customer = api.getCustomer(payload)
                .map(response => InspectionDetailAction.loadCustomerOk(response))
                .catch(error => Observable.of(InspectionDetailAction.loadCustomerError({
                    message: error.message,
                    status: error.status
                })));
            const state = Observable.of(InspectionDetailAction.loadState(payload.userIdentity, payload.requestId));
            const imagesVehicle = Observable.of(InspectionDetailAction.loadPictures(payload.userIdentity, payload.requestId));
            const accessories = Observable.of(InspectionDetailAction.loadAccesories(payload.userIdentity, payload.requestId));
            const damages = Observable.of(InspectionDetailAction.loadPicturesDamages(payload.userIdentity, payload.requestId));
            const picturesObserveds = Observable.of(InspectionDetailAction.loadPicturesObserveds(payload.userIdentity, payload.requestId));
            return Observable.concat(
                inspection,
                state,
                customer,
                imagesVehicle,
                accessories,
                damages,
                picturesObserveds
            )
        });

    static loadPolicy = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_POLICY)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.getPolicy({policyNumber: payload.policyNumber})
                .map(response => InspectionDetailAction.loadPolicyOK(response))
                .catch(error => Observable.of(InspectionDetailAction.loadPolicyError({
                    message: error.message,
                    status: error
                })));
        });

    static loadState = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_STATE)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.getState(payload)
                .map(response => InspectionDetailAction.loadStateOk(response))
                .catch(error => Observable.of(InspectionDetailAction.loadStateError({
                    message: error.message,
                    status: error.status
                })));
        });

    static loadImagesVehicle = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.getPictures(payload)
                .map(response => InspectionDetailAction.loadPicturesOK(response))
                .catch(error => Observable.of(InspectionDetailAction.loadPicturesError({
                    message: error.message,
                    status: error.status
                })));
        });

    static loadPicturesObserveds = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_PICTURES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.loadPicturesObserved(payload)
                .map(response => InspectionDetailAction.loadPicturesObservedsOk(response))
                .catch(error => Observable.of(InspectionDetailAction.loadPicturesObservedsError({
                    message: error.message,
                    status: error.status
                })));
        });

    static loadAccessories = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_ACCESORIES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.getAccesories(payload)
                .map(response => InspectionDetailAction.loadAccesoriesOk(response))
                .catch(error => Observable.of(InspectionDetailAction.loadAccesoriesError({
                    message: error.message,
                    status: error.status
                })));
        });

    static loadDamages = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_DETAIL_INSPECTION_DAMAGES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.getPicturesDamages(payload)
                .map(response => InspectionDetailAction.loadPicturesDamagesOK(response))
                .catch(error => Observable.of(InspectionDetailAction.loadPicturesDamagesError({
                    message: error.message,
                    status: error.status
                })));
        });

    // TODO: pending code review for comments
    static saveComments = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const saveComment = api.saveComment({
                userIdentity: inspection.userIdentity,
                requestId: inspection.id,
                damageComment: inspection.damageComment
            })
                .map(response => InspectionDetailAction.saveCommentsDamagesOk(response.response))
                .catch(error => Observable.of(InspectionDetailAction.saveCommentsDamagesError({
                    message: error.message,
                    status: error.status
                })));
            return Observable.concat(
                saveComment
            )
        });

    static saveCommentsPictures = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const saveComment = api.saveGeneralComment({
                userIdentity: inspection.userIdentity,
                requestId: inspection.id,
                generalComment: inspection.generalComment
            })
                .map(response => InspectionDetailAction.saveCommentsPicturesOk(response.response))
                .catch(error => Observable.of(InspectionDetailAction.saveCommentsPicturesError({
                    message: error.message,
                    status: error.status
                })));
            return Observable.concat(
                saveComment
            )
        });

    static saveCommentsOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_DAMAGES_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_SUCCESSFULLY, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static saveGeneralCommentsOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_SAVE_GENERAL_COMMENT_SUCCESSFULLY, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static saveGeneralCommentsError = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.SAVE_COMMENTS_PICTURES_ERROR)
        .flatMap(() => {
            toast.error(MESSAGES_NOTIFY.MESSAGE_WITHOUT_COMMENT, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static approvedInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            return api.approvedInspection(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.approvedInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.approvedInspectionError({
                    message: error.message,
                    status: error.status
                })));
        });

    static returnToApproved = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_APPROVED)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            return api.returnToApproved(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.returnToApprovedOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.returnToApprovedError({
                    message: error.message,
                    status: error.status
                })));
        });

    static returnToInPerson = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_IN_PERSON)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            return api.returnToInPerson(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.returnToInPersonOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.returnToInPersonError({
                    message: error.message,
                    status: error.status
                })));
        });

    static changeInPersonToCreate = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            return api.inPersonToCreate(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.changeInPersonToCreateOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.changeInPersonToCreateError({
                    message: error.message,
                    status: error.status
                })));
        });

        //changeInPersonToReturn
        static changeInPersonToReturn = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            return api.inPersonToReturn(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.changeInPersonToReturnOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.changeInPersonToReturnError({
                    message: error.message,
                    status: error.status
                })));
        });

    static updateVehiclePlateInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE)
        .flatMap(({payload}) => {
            const params = {
                userIdentity: payload.userIdentity,
                requestId: payload.requestId,
                newVehiclePlate: payload.newVehiclePlate
            };
            const api = new InspectionApi(action$, store, deps);
            return api.updateVehiclePlate(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.updateVehiclePlateInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.updateVehiclePlateInspectionError({
                    message: error.message,
                    status: error.status
                })));
        });

    static removeInspections = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.removeInspections(payload)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.removeInspectionsOk(response))
                ))
                .catch(error => Observable.of(InspectionDetailAction.removeInspectionsError({
                    message: error.message,
                    status: error.status
                })))
        });

    static rejectedInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id, reasonCode: payload};
            const api = new InspectionApi(action$, store, deps);
            return api.rejectedInspection(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.loadInspection(params.userIdentity, params.requestId)),
                    Observable.of(InspectionDetailAction.rejectedInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.rejectedInspectionError({
                    message: error.message,
                    status: error.status
                })));
        });

    static rejectedInspectionOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REJECTED_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_REJECTED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static deriveInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id, reasonCode: payload};
            const api = new InspectionApi(action$, store, deps);
            return api.deriveInspection(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.loadInspection(params.userIdentity, params.requestId)),
                    Observable.of(InspectionDetailAction.deriveInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.deriveInspectionError({
                    message: error.message,
                    status: error.status
                })));
        });

    static presencialInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL)
        .flatMap(({payload}) => {
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: payload.userIdentity, requestId: payload.requestId, body: payload.body};
            const api = new InspectionApi(action$, store, deps);
            return api.presencialInspection(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.presencialInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.presencialInspectionError({
                    message: error.message,
                    status: error.status
                })));
        });

    static deriveInspectionOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_DERIVE_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_DERIVED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static presencialInspectionOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_PRESENCIAL, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static presencialInspectionError = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_PRESENCIAL_ERROR)
        .flatMap(() => {
            toast.warn(MESSAGES_NOTIFY.MESSAGE_TO_PRESENCIAL_ERROR, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static changeInPersonToCreateOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_CREATED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static changeInPersonToCreateError = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_CREATE_ERROR)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_RETURN_ERROR, CONFIG_NOTIFY);
            return Observable.empty();
        });

        //changeInPersonToReturn

        static changeInPersonToReturnOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_RETURN, CONFIG_NOTIFY);
            return Observable.empty();
        });

        static changeInPersonToReturnError = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_IN_PERSON_TO_RETURN_ERROR)
        .flatMap(() => {
            toast.error(MESSAGES_NOTIFY.MESSAGE_TO_RETURN_ERROR, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static updateVehiclePlateInspectionOk = ($action, store, deps) => $action
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_UPDATE, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static updateVehiclePlateInspectionError = ($action, store, deps) => $action
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_UPDATE_VEHICLE_PLATE_ERROR)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_UPDATE_ERROR, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static removeInspectionsOk = ($action, store, deps) => $action
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_REMOVE, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static removeInspectionsError = ($action, store, deps) => $action
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_REMOVE_INSPECTIONS_ERROR)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_REMOVE_ERROR, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static approvedInspectionOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_APPROVED_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_APPROVED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static returnToApprovedOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_APPROVED_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_APPROVED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static returnToInPersonOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_TO_IN_PERSON_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_TO_PRESENCIAL, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static returnInspection = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN)
        .flatMap(({payload}) => {
            const {itemsObserved} = payload;
            const inspection = store.getState().InspectionDetailReducer.inspection;
            const params = {userIdentity: inspection.userIdentity, requestId: inspection.id};
            const api = new InspectionApi(action$, store, deps);
            const requestItems = Observable.of(itemsObserved)
                .map(items =>
                    items.map(item =>
                        api.registerPictureObserved({
                            userIdentity: inspection.userIdentity,
                            requestId: inspection.id,
                            modelReturn: item
                        })
                    ))
                .mergeMap(reqs => Observable.forkJoin(reqs));

            const request = api.returnInspection(params)
                .flatMap(response => Observable.concat(
                    Observable.of(InspectionDetailAction.returnInspectionOk(response)),
                    Observable.of(InspectionDetailAction.loadState(params.userIdentity, params.requestId))
                ))
                .catch(error => Observable.of(InspectionDetailAction.returnInspectionError({
                    message: error.message,
                    status: error.status
                })));

            return Observable.concat(
                requestItems,
                request
            );
        });

    static returnInspectionOk = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_INSPECTION_RETURN_OK)
        .flatMap(() => {
            toast.success(MESSAGES_NOTIFY.MESSAGE_RETURNED, CONFIG_NOTIFY);
            return Observable.empty();
        });

    static validateButtonObservation = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.VALIDATE_BUTTON_OBSERVATION)
        .flatMap(() => {
            let inspection = store.getState().InspectionDetailReducer.inspection;
            let picturesSelected = (inspection.pictures.filter((item) => item.selected).length);
            let damagesSelected = (inspection.damages.filter((item) => item.selected).length);
            let accessoriesSelected = (inspection.accessories.filter((item) => item.selected).length);
            return Observable.of(InspectionDetailAction.validateButtonObservationOk(picturesSelected || damagesSelected || accessoriesSelected));
        });

    static registerPicturesObserved = (action$, store, deps) => action$
        .ofType(INSPECTION_DETAIL_ACTIONS.LOAD_REGISTER_PICTURE_OBSERVED)
        .flatMap(({payload}) => {
            const api = new InspectionApi(action$, store, deps);
            return api.registerPictureObserved({
                userIdentity: payload.userIdentity,
                requestId: payload.requestId,
                modelReturn: payload.modelReturn
            })
                .map(response => InspectionDetailAction.registerPicturesObservedOk(response))
                .catch(error => Observable.of(InspectionDetailAction.registerPicturesObservedError({
                    message: error.message,
                    status: error.status
                })));
        });
}

export default function InspectionDetailEpics(action$, store, deps) {
    return Observable.merge(
        InspectionDetailEpic.loadDetail(action$, store, deps),
        InspectionDetailEpic.loadPolicy(action$, store, deps),
        InspectionDetailEpic.loadState(action$, store, deps),
        InspectionDetailEpic.loadAccessories(action$, store, deps),
        InspectionDetailEpic.saveComments(action$, store, deps),
        InspectionDetailEpic.saveCommentsPictures(action$, store, deps),
        InspectionDetailEpic.saveCommentsOk(action$, store, deps),
        InspectionDetailEpic.saveGeneralCommentsOk(action$, store, deps),
        InspectionDetailEpic.saveGeneralCommentsError(action$, store, deps),
        InspectionDetailEpic.approvedInspection(action$, store, deps),
        InspectionDetailEpic.approvedInspectionOk(action$, store, deps),
        InspectionDetailEpic.returnToApproved(action$, store, deps),
        InspectionDetailEpic.returnToApprovedOk(action$, store, deps),
        InspectionDetailEpic.returnToInPerson(action$, store, deps),
        InspectionDetailEpic.returnToInPersonOk(action$, store, deps),
        InspectionDetailEpic.changeInPersonToCreate(action$, store, deps),
        InspectionDetailEpic.changeInPersonToCreateOk(action$, store, deps),
        InspectionDetailEpic.changeInPersonToCreateError(action$, store, deps),
        //detailsepics for InPersonToReturn
        InspectionDetailEpic.changeInPersonToReturn(action$, store, deps),
        InspectionDetailEpic.changeInPersonToReturnOk(action$, store, deps),
        InspectionDetailEpic.changeInPersonToReturnError(action$, store, deps),
        InspectionDetailEpic.updateVehiclePlateInspection(action$, store, deps),
        InspectionDetailEpic.updateVehiclePlateInspectionOk(action$, store, deps),
        InspectionDetailEpic.updateVehiclePlateInspectionError(action$, store, deps),
        InspectionDetailEpic.removeInspections(action$, store, deps),
        InspectionDetailEpic.removeInspectionsOk(action$, store, deps),
        InspectionDetailEpic.removeInspectionsError(action$, store, deps),
        InspectionDetailEpic.rejectedInspection(action$, store, deps),
        InspectionDetailEpic.rejectedInspectionOk(action$, store, deps),
        InspectionDetailEpic.presencialInspectionError(action$, store, deps),
        InspectionDetailEpic.presencialInspectionOk(action$, store, deps),
        InspectionDetailEpic.presencialInspection(action$, store, deps),
        InspectionDetailEpic.deriveInspection(action$, store, deps),
        InspectionDetailEpic.deriveInspectionOk(action$, store, deps),
        InspectionDetailEpic.returnInspection(action$, store, deps),
        InspectionDetailEpic.returnInspectionOk(action$, store, deps),
        InspectionDetailEpic.loadImagesVehicle(action$, store, deps),
        InspectionDetailEpic.loadDamages(action$, store, deps),
        InspectionDetailEpic.validateButtonObservation(action$, store, deps),
        InspectionDetailEpic.loadPicturesObserveds(action$, store, deps),
        // InspectionDetailEpic.getReportInspection(action$, store, deps),
        // InspectionDetailEpic.getReportInspectionOk(action$, store, deps)

    );
} 



// WEBPACK FOOTER //
// ./src/redux/epics/inspection.js